import { render, staticRenderFns } from "./PlanetaryStationsTable.vue?vue&type=template&id=5957e7a0&"
import script from "./PlanetaryStationsTable.vue?vue&type=script&lang=ts&"
export * from "./PlanetaryStationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports